import { render, staticRenderFns } from "./ManagementManagedServicesGeneralInformation.vue?vue&type=template&id=4970de9a&scoped=true&"
import script from "./ManagementManagedServicesGeneralInformation.vue?vue&type=script&lang=ts&"
export * from "./ManagementManagedServicesGeneralInformation.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4970de9a",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCard,VCol,VForm,VRow,VSelect,VTextField,VTextarea})


/* hot reload */
if (module.hot) {
  var api = require("C:\\Users\\javie\\Documents\\Javier\\Developer\\Landing Dayco\\dayco-cportal-app-client\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4970de9a')) {
      api.createRecord('4970de9a', component.options)
    } else {
      api.reload('4970de9a', component.options)
    }
    module.hot.accept("./ManagementManagedServicesGeneralInformation.vue?vue&type=template&id=4970de9a&scoped=true&", function () {
      api.rerender('4970de9a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tickets/requirement/management-managed-services/components/ManagementManagedServicesGeneralInformation.vue"
export default component.exports